import { api } from "./api";

export const ProcedimentoService = {

  async findAll() {
    const response = await api.get("/procedimentos");
    const data = response.data;

    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    return [];
  },

  async create(data: any) {
    const response = await api.post("/procedimentos", data);
    return response.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/procedimentos/${id}`, data);
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/procedimentos/${id}`);
    return response.data;
  }
};
